import * as activity from './activity';
import * as automation from './automation';
import * as billing from './billing';
import * as bundle from './bundle';
import * as business from './business';
import * as card from './card';
import * as channel from './channel';
import * as chat from './chat';
import * as component from './component';
import * as entity from './entity';
import * as fileOperation from './fileOperation';
import * as report from './report';
import * as search from './search';
import * as thread from './thread';
import * as tool from './tool';
import * as user from './user';
import * as viewTemplate from './viewTemplate';
import * as workflow from './workflow';

export const Fragments = {
  activity,
  automation,
  billing,
  bundle,
  business,
  card,
  channel,
  chat,
  component,
  entity,
  fileOperation,
  report,
  search,
  thread,
  tool,
  user,
  viewTemplate,
  workflow,
};
